import axiosInterseptor from '../../utils/axiosInterseptor';
import { adaptPhotos } from '../../utils/catalogUtils';

class Public {
  static rooms = {
    async getRoomsData(): Promise<any> {
      const response = await fetch(`/roomsData.json`);
      const data = await response.json();
      return data;
    },
  };

  static async getToken(code: string, redirectUri: string, codeVerifier: string) {
    try {
      const response = await axiosInterseptor.post('token', {
        code,
        redirectUri,
        codeVerifier,
      });
      const { data } = response;
      return data;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  static async getProduct(id: number, begin?: string, end?: string, cashback?: boolean) {
    const filters = {
      begin,
      end,
      cashback,
    };
    const params = new URLSearchParams();
    if (filters.begin) {
      params.append('begin', filters.begin);
    }
    if (filters.end) {
      params.append('end', filters.end);
    }
    if (filters.cashback !== undefined) {
      // Для булевых значений приводим их к строке
      params.append('cashback', String(filters.cashback));
    }
    try {
      const queryString = params.toString();
      const baseUrl = `products/product/${id}/data`;
      const paramString = queryString ? `?${queryString}` : '';
      const url = baseUrl + paramString;
      const response = await axiosInterseptor.get(url);
      const { data } = response;
      data.begindate = filters.begin;
      data.photos = adaptPhotos(
        data.photos.photos,
        { photos_url: data.photos.url, photos_res: data.photos.res },
        data.id,
      );
      return data;
    } catch (error) {
      return error;
    }
  }

  static async getQuestionAnswer() {
    try {
      const response = await axiosInterseptor.get('info/faq');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getServiceRules() {
    try {
      const response = await axiosInterseptor.get('info/rules');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getRequisites() {
    try {
      const response = await axiosInterseptor.get('info/props');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getAboutCompany() {
    try {
      const response = await axiosInterseptor.get('info/about');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getProfile() {
    try {
      const response = await axiosInterseptor.get('');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getUserAgreement() {
    try {
      const response = await axiosInterseptor.get('info/user');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }

  static async getUserPoliticsPersonal() {
    try {
      const response = await axiosInterseptor.get('info/personal');
      const { data } = response;
      return data;
    } catch (error) {
      console.error('Ошибка при попытке получения данных с сервера:', error);
      throw error;
    }
  }
}

export default Public;
